<template>
  <v-alert class="custom-alert" :color="color" :icon="icon" dense outlined>
    <slot></slot>
  </v-alert>
</template>

<script>
export default {
  name: "UiAlert",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    icon: String
  }
};
</script>
